import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const formatDate = (dateTime) => {
  if (!dateTime) return '-';
  if (dateTime.includes('T')) {
    const d = new Date(dateTime);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  }
  return `${dateTime.substring(0, 2)}/${dateTime.substring(2, 4)}/${dateTime.substring(4, 8)}`;
};

const MobileChargeSheetsScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;

  const caseDiaryUploaded = Boolean(fir.caseDiary?.text || fir.caseDiary?.bucketFileName);
  const csGenerated = Boolean(fir.caseDiary?.chargeSheet);

  const chargeSheetUploaded = Boolean(fir.chargeSheet?.text || fir.chargeSheet?.bucketFileName);
  const discrepanciesFound = Boolean(fir.caseDiary?.discrepancies);

  return (
    <div>
      <div className="m-card">
        <div style={{ fontSize: '16px', fontWeight: 700, color: '#094268', marginBottom: '6px' }}>Generate Charge Sheet</div>
        {caseDiaryUploaded ? (
          <>
            <div>Case Diary Uploaded: {formatDate(fir.caseDiary.uploadedOn)}</div>
            <div style={{ color: csGenerated ? '#4CAF50' : '#E53935', marginTop: '4px' }}>
              Status: {csGenerated ? 'Completed' : 'Processing'}
            </div>
          </>
        ) : (
          <div style={{ color: '#666' }}>No case diary uploaded yet.</div>
        )}
        <button
          className="m-button-primary"
          style={{ width: 'auto', padding: '8px 14px', marginTop: '10px' }}
          onClick={() => navigate(fir.caseDiary?.bucketFileName ? '/m/fir/chargesheet/generated' : '/m/fir/casediary/new', { state: { fir } })}
        >
          {caseDiaryUploaded ? 'View Generated Charge Sheet' : 'Upload Case Diary'}
        </button>
      </div>

      <div className="m-card">
        <div style={{ fontSize: '16px', fontWeight: 700, color: '#094268', marginBottom: '6px' }}>Verify Charge Sheet</div>
        {chargeSheetUploaded ? (
          <>
            <div>Charge Sheet Uploaded: {formatDate(fir.chargeSheet.uploadedOn)}</div>
            <div style={{ color: discrepanciesFound ? '#4CAF50' : '#E53935', marginTop: '4px' }}>
              Status: {discrepanciesFound ? 'Completed' : 'Processing'}
            </div>
          </>
        ) : (
          <div style={{ color: '#666' }}>No charge sheet uploaded yet.</div>
        )}
        <button
          className="m-button-primary"
          style={{ width: 'auto', padding: '8px 14px', marginTop: '10px' }}
          onClick={() => navigate(chargeSheetUploaded ? '/m/fir/chargesheet/verified' : '/m/fir/chargesheet/new', { state: { fir } })}
        >
          {chargeSheetUploaded ? 'View Verified Charge Sheet' : 'Upload Charge Sheet'}
        </button>
      </div>
    </div>
  );
};

export default MobileChargeSheetsScreen;
